(function () {
  angular.module("akitabox.desktop.export.list", [
    "akitabox.constants",
    "akitabox.core.constants",
    "akitabox.core.services.job.job",
    "akitabox.core.toast",
    "akitabox.ui.dialogs.document.download",
  ]);
})();
